import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
// import CompliancePage from "../pages/Home/Compliance";
import Setting from "../pages/Home/Setting";
import Notification from "../pages/Home/Notificaton";
import Staff from "../pages/Home/Staff";
import Login from "../pages/Login";
import PaymentInfo from "../pages/PaymentInformation";
import PaymentSuccess from "../pages/PaymentInformation/PaymentSuccess";
import NewPaymentMethod from "../pages/NewPaymentMethod";
import SimplePricing from "../pages/SimplePricing";
import ForgetPassword from "../pages/ForgetPassword";
import VerifyEmail from "../pages/VerifyEmail";
import ResetPassword from "../pages/CodeVerification";
import TCandPP from "../pages/TermCondition&PP/TCandPP";
import ContactUs from "../pages/ContactUs";
import CookiesPolicy from "../pages/CookiesPolicy";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import HaveProblem from "../pages/HaveProblem";
import MyTicket from "../pages/Home/MyTicket";
import SingleTicket from "../pages/SingleTicket";
import Landing from "../pages/LandingPage";
import WhyOgiso from "../pages/WhyOgiso";
import PricingComp from "../pages/PricingCopm";
import AdminProfilePage from "../pages/AdminProfile";
import ChatBot from "../utils/chatbot";
import InvoicePayment from "../pages/InvoicePayment";
import Success from "../pages/InvoicePayment/success";
import Error from "../pages/InvoicePayment/error";
import SkypointLogin from "../pages/SkypointLogin";
import SkypointSignup from "../pages/SkypointSignup";
import SkypointCheckEmail from "../pages/SkypointCheckEmail";
import SkypointStaff from "../pages/Home/SkypointStaff";
import SkypointStaffDetails from "../pages/Home/SkypointStaff/SkypointStaffDetails";
import { SkypointStaffAttendance } from "../pages/Home/SkypointStaff/SkypointStaffAttendance";
import SkypointBillingInvoices from "../pages/Home/SkypointBillingInvoices/SkypointBillingInvoices";
import SkypointProvider from "../pages/Home/SkypointProvider";
import SkypointAddProvider from "../pages/Home/SkypointAddProvider";
import QuarterlyReportsPage from "../pages/Home/QuarterlyReportsPage";
import UpgradePlan from "../pages/UpgradePlan";
import { UpdatePlan } from "../pages/UpgradePlan/updatePlan";
import TwoFactorAuthPage from "../pages/TwoFactorAuthPage";
import SelectTwoFactorMethod from "../pages/SelectTwoFactorMethod";
import SkypointSelectTwoFactorMethod from "../pages/SkypointSelectTwoFactorMethod";
import SkypointTwoFactorAuthPage from "../pages/SkypointTwoFactorAuthPage";
import { SkyPointDashboard } from "../pages/Home/Dashboard/SkyPointDashboard";
import { SkyPointPackages } from "../pages/SkyPointPackage";
// import InvoicePaymentSkypoint from "../pages/SkypointInvoicePayment";
// import SuccessSkypoint from "../pages/SkypointInvoicePayment/successSkypoint";
// import ErrorSkypoint from "../pages/SkypointInvoicePayment/errorSkypoint";
import SkypointForgetPassword from "../pages/SkypointForgetPassword";
import SkypointResetPassword from "../pages/CodeVerification/skypoint";
import ErrorSkypoint from "../pages/SkypointInvoicePayment/errorSkypoint";
import SuccessSkypoint from "../pages/SkypointInvoicePayment/successSkypoint";
import InvoicePaymentSkypoint from "../pages/SkypointInvoicePayment";
// import TwoFactorAuthPage from "../pages/TwoFactorAuthPage";

function Router() {
   
  return (
    <>
      {/* <ChatBot /> */}
      <Routes>
        {/* for landing page */}
        <Route path="/" element={<Landing />} />
        {/* <Route path="/signup" element={<AdminProfilePage />} /> */}
        {/* <Route path="/login" element={<Login />} /> */}
        <Route path="/2fa" element={<TwoFactorAuthPage />} />
        <Route path="/select-2fa-method" element={<SelectTwoFactorMethod />} />
        <Route path="/whyogiso" element={<WhyOgiso />} />
        <Route path="/pricing" element={<PricingComp />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/reset-password-skypoint/:token" element={<SkypointResetPassword />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/verify-email-update/:token" element={<VerifyEmail />} />

        {/* for skypoint */}
        <Route path="/skypoint-login" element={<SkypointLogin />} />
        <Route path="/skypoint-signup" element={<SkypointSignup />} />
        <Route path="/skypoint-forget-password" element={<SkypointForgetPassword />} />
        <Route path="/skypoint-check-email" element={<SkypointCheckEmail />} />
        <Route path="/skypoint-select-2fa-method" element={<SkypointSelectTwoFactorMethod />} />
        <Route path="/skypoint-2fa" element={<SkypointTwoFactorAuthPage />} />
        <Route path="/skypoint-packages" element={<SkyPointPackages />} />
        {/* <Route path="/confirm-upgrade-plan" element={<UpgradePlan />} /> */}
        <Route path="/confirm-update-plan" element={<UpdatePlan />} />

        {/* for invoicepayment */}
        <Route path="/invoice-payment" element={<InvoicePayment />} />
        <Route path="/success" element={<Success />} />
        <Route path="/error" element={<Error />} />

        <Route path="/invoice-payment-skypoint" element={<InvoicePaymentSkypoint />} />
        <Route path="/success-skypoint" element={<SuccessSkypoint />} />
        <Route path="/error-skypoint" element={<ErrorSkypoint />} />


        {/* for invoicepayment */}
        <Route path="/selectprice" element={<SimplePricing />} />
        <Route path="/payInfo" element={<PaymentInfo />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/add-payment" element={<NewPaymentMethod />} />
        <Route path="/term-conditions" element={<TCandPP />} />
        <Route path="/cookies-policy" element={<CookiesPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* for home */}
        <Route path="/home/*" element={<Home />}>
          <Route path="dashboard-skypoint" element={<SkyPointDashboard />} />
          <Route path="staff-skypoint" element={<SkypointStaff />} />
          <Route path="provider-skypoint" element={<SkypointProvider />} />
          <Route
            path="provider-skypoint/:mode"
            element={<SkypointAddProvider />}
          />

          <Route
            path="staff-skypoint/:id/:mode"
            element={<SkypointStaffDetails />}
          />
          <Route
            path="staff-skypoint/manage-attendance/:id"
            element={<SkypointStaffAttendance />}
          />
          <Route
            path="invoices-skypoint"
            element={<SkypointBillingInvoices />}
          />
          <Route path="report-skypoint" element={<QuarterlyReportsPage />} />
          <Route path="settings" element={<Setting />} />
          
          {/* <Route path="supportPlan" element={<SupportPlan />} />
          <Route path="staff" element={<Staff />} /> */}
          {/* <Route path="compliance" element={<CompliancePage />} /> */}
          {/* <Route path="patient" element={<Patient />} />
          <Route path="note" element={<Dashboard />} />
          <Route path="notetype" element={<NoteType />} />
          <Route path="notifications" element={<Notification />} />
          <Route path="tickets" element={<MyTicket />} />
          <Route path="ticket/:id" element={<SingleTicket />} />
          <Route path="create-ticket" element={<HaveProblem />} />
          <Route path="billing" element={<Billing />} />
          <Route path="billing-claim-form" element={<BillingClaimForm />} />
          <Route path="invoices" element={<BillingInvoices />} /> */}
        </Route>
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
      </Routes>
    </>
  );
}

export default Router;
